//Generates a new access token and adds it to the store
import jwt from "jsonwebtoken";
import router from "../router";

import axios from "axios";

//A password change replaces the refresh cookie and access token. A refresh racing it would still
//send the old cookie and either fail (logging this device out) or bring back a token the API has
//just invalidated, so the two never overlap
let refreshInFlight = null;
let sessionChangeInFlight = null;

export async function refreshAccessToken(store) {
    if(sessionChangeInFlight) {
        await sessionChangeInFlight.catch(() => {});
    }
    //Callers asking at the same time share one request
    if(!refreshInFlight) {
        refreshInFlight = requestNewAccessToken(store).finally(() => {
            refreshInFlight = null;
        });
    }
    return refreshInFlight;
}

async function requestNewAccessToken(store) {
    let tokenBefore = localStorage.getItem("accessToken");
    let url = process.env.VUE_APP_API_URL+"refresh-token";
    const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        credentials: "include",

    });
    let jsonResponse = await response.json();
    //Another tab stored a newer token (e.g. it just changed the password) while this was in flight
    let tokenNow = localStorage.getItem("accessToken");
    if(tokenNow && tokenNow !== tokenBefore) {
        store.commit('SET_ACCESS_TOKEN', tokenNow);
        return tokenNow;
    }
    if(jsonResponse.ok === false) {
        localStorage.clear();
        return false;
    }
    let accessToken = jsonResponse.accessToken;
    store.commit('SET_ACCESS_TOKEN', accessToken);
    localStorage.setItem("accessToken", accessToken);
    return accessToken;
}

//Checks if the token has expired or exists and returns false
export function isAccessTokenValid(store) {
    let accessToken = jwt.decode(store.getters.accessToken)
    if(accessToken == null) {
        return false;
    }
    let currentDate = new Date().getTime();
    let expiredTime = accessToken.exp;
    //Minus 5 seconds from expire time so it doesn't expire over the network
    return !(currentDate / 1000 > (expiredTime-5));
}

//Runs a request that issues new session tokens (password change) with no token refresh overlapping it
export async function withSessionChange(request) {
    if(refreshInFlight) {
        await refreshInFlight.catch(() => {});
    }
    sessionChangeInFlight = Promise.resolve().then(request);
    try {
        return await sessionChangeInFlight;
    } finally {
        sessionChangeInFlight = null;
    }
}

//Drops the local session (access token and everything cached for the user) without calling the API
export function clearLocalSession(store) {
    store.commit('SET_ACCESS_TOKEN', null);
    localStorage.clear();
}

export async function getAccessToken(store) {
    if(isAccessTokenValid(store)) {
        return store.getters.accessToken;
    }
    //If the accessToken is false it means the refresh token as expired
    const accessToken = await refreshAccessToken(store);
    if(accessToken === false) {
        //Refresh token invalid, redirect to homepage
        store.commit('SET_ACCESS_TOKEN', null);
        //router.push({path: '/jwt-login'})
    } else {
        return accessToken;
    }

}
